import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { IconAlertTriangle } from '@rossum/ui/icons/tabler';
import { Button, Stack, SvgIcon, Typography } from '@rossum/ui/material';

export const PricingBanner = ({
  warningText,
  billingEnabled,
}: {
  warningText: string;
  billingEnabled: boolean;
}) => {
  const intl = useIntl();
  return (
    <Stack
      direction="row"
      spacing={1}
      py={1}
      px={1.5}
      alignItems="center"
      sx={{
        backgroundColor: 'warning.main',
        color: t => t.palette.getContrastText(t.palette.warning.main),
      }}
      data-cy="pricing-banner"
    >
      <SvgIcon fontSize="large">
        <IconAlertTriangle />
      </SvgIcon>
      <Typography whiteSpace="nowrap" variant="h6">
        {intl.formatMessage({ id: 'features.pricing.banner.title' })}
      </Typography>
      <Typography
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        overflow="hidden"
        minWidth={0}
        variant="body2"
      >
        {warningText}
      </Typography>
      {billingEnabled ? (
        <Stack flex={1}>
          <Button
            color="inherit"
            sx={{
              alignSelf: 'flex-end',
              py: 0.5,
              '&:hover': {
                color: 'unset',
              },
            }}
            component={RouterLink}
            to="/billing/my-plan"
            data-cy="pricing-banner-view-more-button"
          >
            {intl.formatMessage({ id: 'features.pricing.banner.button' })}
          </Button>
        </Stack>
      ) : null}
    </Stack>
  );
};
